import React from "react";
// import { ReactComponent as LogoSvg } from "../assets/logo.svg";
import logo from "../assets/logo.png";
const Logo = () => {
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12 flex justify-center items-center">
        {/* <LogoSvg /> */}
        <img width={350} src={logo} />
      </div>
    </div>
  );
};

export default Logo;
